angular.module('directives.authentication')
    .directive('loginForm', ['Authentication', 'Localization', '$state', function(Authentication, Localization, $state) {

        return {
            restrict: 'A',
            template: require('../templates/loginForm.html'),
            link: postLink
        };

        function postLink($scope, el, attrs, controller) {
            $scope.logIn = function (form) {
                if (form.$invalid) {
                    if (!form.email.$valid) {
                        Localization.notifyTemplate('error', 'ERRORS.INCORRECT_LOGIN', 66666666665, true);
                        return;
                    }

                    if (!form.password.$valid) {
                        Localization.notifyTemplate('error', 'ERRORS.INVALID_PASSWORD', 5323123213, true);
                        if (form.password.$viewValue && !form.password.$valid) {
                            $state.go('pages.password-recovery');
                        }
                        return;
                    }
                }

                $scope.preLoader = true;

                var loginData = {
                    email: form.email.$modelValue,
                    password: form.password.$modelValue
                };
                Authentication.login(loginData).then(
                    function () {
                        $state.go('pages.services', { categoryId: 'all' });
                    },
                    function () {
                        Localization.notifyTemplate('error', 'ERRORS.AUTH_ERROR', 5, true);
                    }
                ).finally(function () {
                    $scope.preLoader = false;
                });
            };
        }
    }]);

module.exports = 'directives.authentication';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authentication/directives/loginForm.directive.js
 ** module id = 124
 ** module chunks = 1
 **/